import {CountUp} from "countup.js";

/**
 * Invoke countup on countup elements when they become visible on screen
 */
(function (Drupal, once) {

  Drupal.behaviors.numberCountup = {

    attach(context, settings) {
      if (!'IntersectionObserver' in window) {
        return false;
      }

      const elements = once('countupEls', '.countup');

      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach (countElEntry => {
          if (countElEntry.isIntersecting) {
            let countEl = countElEntry.target;
            let value = countEl.dataset.countup;
            const options = { decimalPlaces: countDecimals(parseFloat(value)), };
            let cup = new CountUp(countEl, value, options);

            cup.start();

            observer.unobserve(countElEntry.target);
          }
        });
      }, {
        rootMargin: "0px 0px -100px 0px"
      });

      elements.forEach (countEl => {
        observer.observe(countEl);
      });
    }
  }

}(Drupal, once));

var countDecimals = function (value) {
    if(Math.floor(value) === value) return 0;
    return value.toString().split(".")[1].length || 0; 
}

